import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type WorkForm from 'modules/employees/lib/forms/EmployeeForm/WorkInformation'

interface Props {
  employeeName: string
  workForm: WorkForm
  onClose: () => void
  onSubmit: () => Promise<void> | void
  running?: boolean
}

const ManagerTogglerModal = ({
  employeeName,
  workForm,
  onClose,
  onSubmit,
  running = false,
}: Props) => {
  const translationOptions = {
    user: employeeName,
  }

  const onSubmitForm = () => {
    workForm.get('timeoff_manager_id').set(workForm.get('manager_id').value)

    return onSubmit()
  }

  return (
    <Modal
      title={i18n.t('employee_form.set_manager_modal.title_v2', translationOptions)}
      description={i18n.t(
        'employee_form.set_manager_modal.manager_description_v2',
        translationOptions
      )}
      illustration="user-remove"
      onSubmit={onSubmitForm}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" disabled={running} onClick={onSubmit}>
            {i18n.t('common.no_thanks')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.ok_sure')}
          </Button>
        </>
      }
    />
  )
}

export default ManagerTogglerModal
